export default "__VITE_ASSET__b678a35a__"